import Vue from 'vue';
import flywheelSFMCUtilFactory from "@/services/flywheel-sfmc-util"
import ProcessStatus from "@/services/process-status"

var FlywheelDEService;

Vue.util.extend(
    (FlywheelDEService = function(component) {
        this.flywheelDEUtil = flywheelSFMCUtilFactory(component, "de");
    }).prototype,
    {
        STATE_UNPROCESSED: "unprocessed",
        STATE_QUEUED: "queued",
        STATE_PROCESSED: "processed",
        dataExtensionsSequence: 1,
        dataExtensionAdd: function() {
            return {
                id: this.dataExtensionsSequence++,
                processStatus: new ProcessStatus(this.STATE_UNPROCESSED),
                params: {},
                rows: []
            };
        },
        processDataExtension: function(dataExtension) {
            var params = dataExtension.params;
            var rows = dataExtension.rows;
            var processStatus = dataExtension.processStatus;
            return this.flywheelDEUtil.apiCall("retrieve", {
                search_property: "Name",
                search_property_value: params.name,
                single_result: true
            })
            .then(
                (response) => {
                    if (response.data) {
                        return Promise.reject({
                            apiResponseRaw: null,
                            apiResponseMessage: "Data extension alread exists.  Cannot create and insert records."
                        });
                    } else {
                        return this.flywheelDEUtil.apiCall("create", params);
                    }
                }
            )
            .then(
                () => {
                    return this.flywheelDEUtil.apiCall(
                        "insert_rows",
                        {
                            name: params.name,
                            rows: this.flywheelDEUtil.makeRowsParam(
                                params.properties.Fields.Field,
                                rows
                            )
                        }
                    )
                }
            )
            .then(
                () => {
                    processStatus.state = this.STATE_PROCESSED;
                    return Promise.resolve();
                },
                (errorResponse) => {
                    processStatus.state = this.STATE_UNPROCESSED;
                    processStatus.error(errorResponse.apiResponseMessage, errorResponse.apiResponseRaw);
                    return Promise.resolve();
                }
            )
        },
        processDataExtensions: function(dataExtensions) {
            var dataExtensionTgts = [];
            var processIter = () => {
                if (dataExtensionTgts.length) {
                    return this.processDataExtension(dataExtensionTgts.shift())
                    .then(
                        () => processIter()
                    );
                } else {
                    return Promise.resolve();
                }
            };
            dataExtensions.forEach(dataExtension => {
                if (dataExtension.processStatus.state == this.STATE_UNPROCESSED) {
                    dataExtension.processStatus.state = this.STATE_QUEUED;
                    dataExtension.processStatus.reset();
                    dataExtensionTgts.push(dataExtension);
                }
            });
            return processIter();
        }
    }
);

export default function(component) {
    return new FlywheelDEService(component);
}